export default __webpack_public_path__ + "static/nfpa_w.f7ec747c1f4ba87e26a41b42ee9d09e3.png";